import { render, staticRenderFns } from "./ReleaseNotesNew.vue?vue&type=template&id=805d6450"
import script from "./ReleaseNotesNew.vue?vue&type=script&lang=ts"
export * from "./ReleaseNotesNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports